export enum EConfigurationStatus {
  RESOLVABLE = 'RESOLVABLE',
  OK         = 'OK',
}

export const DAYS_FROM_TODAY_TO_START_CONTRACT = 14;
